import { PermissionActions } from '@/features/permissions/permissionActions.js'
import { SuperAdminLimitedMasterViewActions } from '@/features/superAdmin/superAdminLimitedPermissionActions.js'

export const masterRoutes = [
  {
    path: 'master',
    component: () => import('@/features/superAdmin/master/MasterManagementView.vue'),
    meta: {
      layoutPadding: false,
      permissionAnyActions: SuperAdminLimitedMasterViewActions,
    },
    children: [
      {
        path: 'brands',
        component: () => import('@/features/ui/components/DummyRouter.vue'),
        meta: {
          permissionAction: PermissionActions.SuperAdminLimitedMasterBrandsView,
        },
        children: [
          {
            path: '',
            component: () => import('@/features/superAdmin/master/brand/list/BrandListView.vue'),
            meta: {
              permissionAction: PermissionActions.SuperAdminLimitedMasterBrandsView,
            },
          },
          {
            path: ':brandId',
            component: () => import('@/features/superAdmin/master/brand/edit/BrandEditView.vue'),
            meta: {
              permissionAction: PermissionActions.SuperAdminLimitedMasterBrandsView,
            },
          },
          {
            path: 'new',
            component: () => import('@/features/superAdmin/master/brand/edit/BrandEditView.vue'),
            meta: {
              permissionAction: PermissionActions.SuperAdminLimitedMasterBrandsCreate,
            },
          },
        ],
      },
      {
        path: 'components',
        component: () => import('@/features/ui/components/DummyRouter.vue'),
        meta: {
          permissionAction: PermissionActions.SuperAdminLimitedMasterComponentsView,
        },
        children: [
          {
            path: '',
            component: () =>
              import('@/features/superAdmin/master/components/list/ComponentsListView.vue'),
            meta: {
              permissionAction: PermissionActions.SuperAdminLimitedMasterComponentsView,
            },
          },
          {
            path: ':componentId',
            component: () =>
              import('@/features/superAdmin/master/components/edit/ComponentsEditView.vue'),
            meta: {
              permissionAction: PermissionActions.SuperAdminLimitedMasterComponentsView,
            },
          },
          {
            path: 'new',
            component: () =>
              import('@/features/superAdmin/master/components/edit/ComponentsEditView.vue'),
            meta: {
              permissionAction: PermissionActions.SuperAdminLimitedMasterComponentsCreate,
            },
          },
        ],
      },
      {
        path: 'countries',
        component: () => import('@/features/ui/components/DummyRouter.vue'),
        meta: {
          permissionAction: PermissionActions.SuperAdminLimitedMasterCountriesView,
        },
        children: [
          {
            path: '',
            component: () =>
              import('@/features/superAdmin/master/country/list/CountryListView.vue'),
            meta: {
              permissionAction: PermissionActions.SuperAdminLimitedMasterCountriesView,
            },
          },
          {
            path: ':countryId',
            component: () =>
              import('@/features/superAdmin/master/country/edit/CountryEditView.vue'),
            meta: {
              permissionAction: PermissionActions.SuperAdminLimitedMasterCountriesView,
            },
          },
          {
            path: 'new',
            component: () =>
              import('@/features/superAdmin/master/country/edit/CountryEditView.vue'),
            meta: {
              permissionAction: PermissionActions.SuperAdminLimitedMasterCountriesCreate,
            },
          },
        ],
      },
      {
        path: 'sport-categories',
        component: () => import('@/features/ui/components/DummyRouter.vue'),
        meta: {
          permissionAction: PermissionActions.SuperAdminLimitedMasterSportCategoriesView,
        },
        children: [
          {
            path: '',
            component: () =>
              import('@/features/superAdmin/master/sportCategory/list/SportCategoryListView.vue'),
            meta: {
              permissionAction: PermissionActions.SuperAdminLimitedMasterSportCategoriesView,
            },
          },
          {
            path: ':sportCategoryId',
            component: () =>
              import('@/features/superAdmin/master/sportCategory/edit/SportCategoryEditView.vue'),
            meta: {
              permissionAction: PermissionActions.SuperAdminLimitedMasterSportCategoriesView,
            },
          },
          {
            path: 'new',
            component: () =>
              import('@/features/superAdmin/master/sportCategory/edit/SportCategoryEditView.vue'),
            meta: {
              permissionAction: PermissionActions.SuperAdminLimitedMasterSportCategoriesCreate,
            },
          },
        ],
      },
      {
        path: 'tenant-definitions',
        component: () => import('@/features/ui/components/DummyRouter.vue'),
        meta: {
          permissionAction: PermissionActions.SuperAdminLimitedMasterTenantDefinitionsView,
        },
        children: [
          {
            path: '',
            component: () =>
              import('@/features/superAdmin/master/tenantDefinition/list/TenantDefinitionListView.vue'),
            meta: {
              permissionAction: PermissionActions.SuperAdminLimitedMasterTenantDefinitionsView,
            },
          },
          {
            path: ':tenantDefinitionId',
            component: () =>
              import('@/features/superAdmin/master/tenantDefinition/edit/TenantDefinitionEditView.vue'),
            meta: {
              permissionAction: PermissionActions.SuperAdminLimitedMasterTenantDefinitionsView,
            },
          },
          {
            path: 'new',
            component: () =>
              import('@/features/superAdmin/master/tenantDefinition/edit/TenantDefinitionEditView.vue'),
            meta: {
              permissionAction: PermissionActions.SuperAdminLimitedMasterTenantDefinitionsCreate,
            },
          },
        ],
      },
      {
        path: 'terminologies',
        component: () => import('@/features/ui/components/DummyRouter.vue'),
        meta: {
          permissionAction: PermissionActions.SuperAdminLimitedMasterTerminologiesView,
        },
        children: [
          {
            path: '',
            component: () =>
              import('@/features/superAdmin/master/terminology/list/TerminologyListView.vue'),
            meta: {
              permissionAction: PermissionActions.SuperAdminLimitedMasterTerminologiesView,
            },
          },
          {
            path: ':terminologyId',
            component: () =>
              import('@/features/superAdmin/master/terminology/edit/TerminologyEditView.vue'),
            meta: {
              permissionAction: PermissionActions.SuperAdminLimitedMasterTerminologiesView,
            },
          },
          {
            path: 'new',
            component: () =>
              import('@/features/superAdmin/master/terminology/edit/TerminologyEditView.vue'),
            meta: {
              permissionAction: PermissionActions.SuperAdminLimitedMasterTerminologiesCreate,
            },
          },
        ],
      },

      {
        path: 'profile-organization-roles',
        component: () => import('@/features/ui/components/DummyRouter.vue'),
        meta: {
          permissionAction: PermissionActions.SuperAdminLimitedMasterProfileOrganizationRolesView,
        },
        children: [
          {
            path: '',
            component: () =>
              import('@/features/superAdmin/master/organizationRole/list/OrganizationRoleListView.vue'),
            meta: {
              permissionAction:
                PermissionActions.SuperAdminLimitedMasterProfileOrganizationRolesView,
            },
          },
          {
            path: ':profileOrganizationRoleId',
            component: () =>
              import('@/features/superAdmin/master/organizationRole/edit/OrganizationRoleEditView.vue'),
            meta: {
              permissionAction:
                PermissionActions.SuperAdminLimitedMasterProfileOrganizationRolesView,
            },
          },
          {
            path: 'new',
            component: () =>
              import('@/features/superAdmin/master/organizationRole/edit/OrganizationRoleEditView.vue'),
            meta: {
              permissionAction:
                PermissionActions.SuperAdminLimitedMasterProfileOrganizationRolesCreate,
            },
          },
        ],
      },

      {
        path: 'osi-access',
        component: () => import('@/features/ui/components/DummyRouter.vue'),
        meta: {
          permissionAction: PermissionActions.SuperAdminLimitedMasterOsiAccessModulesView,
        },
        children: [
          {
            path: '',
            component: () =>
              import('@/features/superAdmin/master/osiAccess/list/OsiAccessListView.vue'),
            meta: {
              permissionAction: PermissionActions.SuperAdminLimitedMasterOsiAccessModulesView,
            },
          },
          {
            path: ':osiAccessId',
            component: () =>
              import('@/features/superAdmin/master/osiAccess/edit/OsiAccessEditView.vue'),
            meta: {
              permissionAction: PermissionActions.SuperAdminLimitedMasterOsiAccessModulesView,
            },
          },
          {
            path: 'new',
            component: () =>
              import('@/features/superAdmin/master/osiAccess/edit/OsiAccessEditView.vue'),
            meta: {
              permissionAction: PermissionActions.SuperAdminLimitedMasterOsiAccessModulesCreate,
            },
          },
        ],
      },

      {
        path: 'sport-types',
        component: () => import('@/features/ui/components/DummyRouter.vue'),
        meta: {
          permissionAction: PermissionActions.SuperAdminLimitedMasterSportTypesView,
        },
        children: [
          {
            path: '',
            component: () =>
              import('@/features/superAdmin/master/sportType/list/SportTypeListView.vue'),
            meta: {
              permissionAction: PermissionActions.SuperAdminLimitedMasterSportTypesView,
            },
          },
          {
            path: ':sportTypeId',
            component: () =>
              import('@/features/superAdmin/master/sportType/edit/SportTypeEditView.vue'),
            meta: {
              permissionAction: PermissionActions.SuperAdminLimitedMasterSportTypesView,
            },
          },
          {
            path: 'new',
            component: () =>
              import('@/features/superAdmin/master/sportType/edit/SportTypeEditView.vue'),
            meta: {
              permissionAction: PermissionActions.SuperAdminLimitedMasterSportTypesCreate,
            },
          },
        ],
      },
      {
        path: 'role-management',
        redirect: '/super-admin/role-management',
      },
      {
        path: 'role-management/:roleId',
        redirect: to => `/super-admin/role-management/${to.params.roleId}`,
      },
    ],
  },
]
